import { combineReducers } from "redux";
import { entryReducer } from "./entryReducer";
import { coverageReducer } from "./coverageReducer";
import { patientInfoScreeningReducer } from "./patientInfoScreeningReducer";
import { householdMembersReducer } from "./householdMembersReducer";
import { personInfoScreeningReducer } from "./personInfoScreeningReducer";
import { governmentReducer } from "./governmentReducer";
import { financialAssistanceReducer } from "./financialAssistanceReducer";
import { interviewAssetsReducer } from "./interviewAssetsReducer";
import { interviewProgramReducer } from "./interviewProgramReducer";
import { supplementalReducer } from "./supplementalReducer";
import { uiStatusReducer } from "./uiStatus";
import { createReducerFromMap } from "@coverme/redux";
import { interviewLiabilitiesReducer } from "./interviewLiabilitiesReducer";
import { encounterHistoryReducer } from "./encounterHistoryReducer";
import { wizardStatusReducer } from "./wizardStatusReducer";
import { exchangeReducer } from "./exchangeReducer";
import { personVerificationReducer } from "./personVerificationReducer";
import { longTermCareReducer } from "./longTermCareReducer";

const encounterIdReducer = createReducerFromMap(null, {
    UPDATE_ENTRY_COMPLETE: (state, action) => action.value.encounterId,
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.entry.encounterId,
    RESET_INTERVIEW: () => null,
});

const encounterSourceReducer = createReducerFromMap("", {
    UPDATE_ENCOUNTER_SOURCE_COMPLETE: (state, action) => action.value,
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.encounterSource,
    RESET_INTERVIEW: () => "",
});

const encounterStatusReducer = createReducerFromMap("", {
    UPDATE_ENCOUNTER_STATUS_COMPLETE: (state, action) => action.value,
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.encounterStatus,
    RESET_INTERVIEW: () => "",
});

const encounterTagReducer = createReducerFromMap("", {
    ADD_TAG_COMPLETE: (state, action) => action.value,
    DELETE_TAG_COMPLETE: (state, action) => action.value,
    GET_ENCOUNTER_TAG_COMPLETE: (state, action) => action.value,
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.encounterTag,
    RESET_INTERVIEW: () => "",
});

const createdReducer = createReducerFromMap("", {
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.created,
    RESET_INTERVIEW: () => "",
});

const lastUpdatedReducer = createReducerFromMap("", {
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.lastUpdated,
    RESET_INTERVIEW: () => "",
});

const encounterDateReducer = createReducerFromMap("", {
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.encounterDate,
    RESET_INTERVIEW: () => "",
});

const encounterPaymentPreference = createReducerFromMap("", {
    GET_INTERVIEW_COMPLETE: (state, action) => action.value.isMarketplaceCreditApproved,
    RESET_INTERVIEW: () => "",
});

// paymentDetails

const paymentDetailsReducer = createReducerFromMap(
    {},
    {
        GET_INTERVIEW_COMPLETE: (state, action) => {
            if (action.value.paymentDetails != null) {
                return action.value.paymentDetails;
            }

            return {};
        },
        RESET_INTERVIEW: (state, action) => {
            return {};
        },
    }
);

const combinedReducer = combineReducers({
    entry: entryReducer,
    coverage: coverageReducer,
    verifications: personVerificationReducer,
    patientInfoScreening: patientInfoScreeningReducer,
    householdMembers: householdMembersReducer,
    personInfoScreening: personInfoScreeningReducer,
    government: governmentReducer,
    financialAssistance: financialAssistanceReducer,
    assets: interviewAssetsReducer,
    longTermCare: longTermCareReducer,
    programs: interviewProgramReducer,
    exchange: exchangeReducer,
    supplemental: supplementalReducer,
    ui: uiStatusReducer,
    encounterId: encounterIdReducer,
    encounterStatus: encounterStatusReducer,
    encounterTag: encounterTagReducer,
    encounterSource: encounterSourceReducer,
    created: createdReducer,
    lastUpdated: lastUpdatedReducer,
    liabilities: interviewLiabilitiesReducer,
    history: encounterHistoryReducer,
    encounterDate: encounterDateReducer,
    wizard: wizardStatusReducer,
    paymentDetails: paymentDetailsReducer,
    isMarketplaceCreditApproved: encounterPaymentPreference,
});

export function interviewReducer(state, action) {
    const intermediateState = combinedReducer(state, action);
    return intermediateState;
}
